import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import Directory from '../../components/directory/directory.component';
import HeroVideo from '../../components/hero-video/hero-video.component';
import florImage from '../../images/flor.jpg';
import haschImage from '../../images/hasch.jpg';
import { scrollTop } from '../../utils/utils';
import { whoWeAreParagraphs } from './textWhoWeAre';
import './home.styles.scss';

const categories = [
  {
    id: 1,
    overline: 'Indoor & greenhouse',
    title: 'Fleurs',
    imageUrl: florImage,
    route: 'shop/fleurs'
  },
  {
    id: 2,
    overline: 'Résines & extractions',
    title: 'Hasch',
    imageUrl: haschImage,
    route: 'shop/hasch'
  }
];

const Home = () => {
  return (
    <>
      <HeroVideo />
      <Directory categories={categories} />
      <section className="who-we-are" aria-labelledby="who-we-are-title">
        <div>
          <h2 className="who-we-are-title" id="who-we-are-title">
            Qui sommes-nous ?
          </h2>

          {whoWeAreParagraphs.map((paragraph) => (
            <p className="who-we-are-lead" key={paragraph}>
              {paragraph}
            </p>
          ))}

          <Link
            className="brand-link who-we-are-cta"
            to="/shop"
            onClick={scrollTop}
          >
            Voir la boutique
            <span className="brand-link-arrow" aria-hidden="true">
              <BsArrowRight />
            </span>
          </Link>
        </div>

        <div className="who-we-are-media">
          <iframe
            src="https://www.youtube.com/embed/DjwNDIrxe8Y"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </section>
    </>
  );
};

export default Home;
